import { Node } from "#/decision_tree_viewer/models/node";

export class InfoNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "InfoNode",

      title: undefined,
      message: undefined,

      targetNodeId: "continue",
    };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  nextNodeId() {
    return this.targetNodeId;
  }
}
